import {useCallback} from 'react';

import {useDocumentRepository} from '@/components/document/repository';
import {useDocumentUtils} from '@/components/document/utils';
import {useConfig} from '@/contexts/config/config.hooks';
import {VisibilitySet} from '@/engine';
import {serializeDocument} from '@/utils/document/serializer';

type Props = {
  visibilitySet: VisibilitySet;
};

export const useSaveChanges = ({visibilitySet}: Props) => {
  const {model} = useConfig();
  const {store, valueResolver} = useDocumentUtils();
  const {saveDocument} = useDocumentRepository();

  return useCallback(async () => {
    const state = store.getState();

    const updatedDocument = serializeDocument(
      {data: state.data, meta: state.meta},
      model,
      visibilitySet,
      valueResolver,
    );

    await saveDocument(updatedDocument);
  }, [model, saveDocument, store, valueResolver, visibilitySet]);
};
